import script from "./GorillaSafetyBasic.vue?vue&type=script&setup=true&lang=ts"
export * from "./GorillaSafetyBasic.vue?vue&type=script&setup=true&lang=ts"

import "./GorillaSafetyBasic.vue?vue&type=style&index=0&id=3d0662bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0662bc"]])

export default __exports__